export default (state = localStorage.getItem('lng') || 'en', action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      localStorage.setItem('lng', action.value)
      return action.value
    default:
      return state
  }
}
